import {motion, animate} from 'framer-motion';
import { useEffect, useRef } from "react";

const Progressbar = (props) => {
    const progressTextRef = useRef(null);
    useEffect(() => {
        const progressText = progressTextRef.current?.textContent;
        if(progressText != null) {
            animate(parseInt(progressText),props.value, {
                duration: 2,
                onUpdate : (cv) => {
                    progressTextRef.current.textContent = cv.toFixed(0)
                }
            });
        }
    }, [props.value]);
    return(
        <div className="progressbar-container">
            <div className="progressbar">
                <motion.div 
                className="bar"
                animate={{
                    width: `${props.value}%`
                }}
                transition={{
                    duration: 2
                }}
                />
            </div>
            <div className="progressbar-text-container">
                <p ref={progressTextRef}>0</p>
                <p>%</p>
            </div>
        </div>
    );
}

export default Progressbar;